import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface LinkProps {
  link?: {
    label?: string;
    isAnchorLink?: boolean;
    anchorId?: string;
    displayName?: string;
  };
}

interface Props {
  navLinks?: Array<LinkProps>;
  className?: string;
}

const NavLinks = ({ navLinks, className }: Props) => (
  <ul className={classNames('list-none', className)}>
    {navLinks?.map(({ link }, i) => {
      const linkObj = buildLinkObj(link);
      const handleNavButtonClick = (anchorId?: string) => {
        const stickyNavBar = 'stickyNavBar';
        const anchorElement = document?.querySelector(`#${anchorId}`) || null;
        const stickyNavBarHeight =
          document?.querySelector<HTMLElement>(`#${stickyNavBar}`)?.offsetHeight || 0;
        const top = anchorElement?.getBoundingClientRect()?.top ?? 0;

        const y = top + window.scrollY - stickyNavBarHeight - 120;

        window.scrollTo({ top: y, behavior: 'smooth' });
      };

      return (
        <li key={i}>
          {link?.isAnchorLink ? (
            <button
              type="button"
              aria-label={link?.label || 'Scroll to page section below'}
              onClick={() => handleNavButtonClick(link?.anchorId)}
              className="tra-text-web-sub-3 text-neutral-50 p-4 hover:text-brand-200 transition-colors duration-300"
            >
              {link.displayName}
            </button>
          ) : (
            <a
              rel={getRel(linkObj)}
              href={linkObj.href}
              aria-label={link?.label || 'Link to another page'}
              className="tra-text-web-sub-3 text-neutral-50 p-4 hover:text-brand-200 transition-colors duration-300"
            >
              <div>{linkObj.text}</div>
            </a>
          )}
        </li>
      );
    })}
  </ul>
);

export default NavLinks;
